import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchStaffCountService } from '../../services/user/staffCountService';
export const fetchStaffCountAsync = createAsyncThunk(
  'staff/staffCount',
  async ( thunkAPI) => { // Add thunkAPI as the second argument
    const response = await fetchStaffCountService();
    return response;
  }
);
